import { render, staticRenderFns } from "./BaseRadiobutton.vue?vue&type=template&id=1e0589a2&"
import script from "./BaseRadiobutton.vue?vue&type=script&lang=js&"
export * from "./BaseRadiobutton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports